module.exports = __webpack_public_path__ + "img/les-mots.25cd39ff.svg";